import React, { Component } from 'react'
import { browserHistory } from 'react-router'
import { observer } from 'mobx-react'
import { 
    Button,
    Col,
    ControlLabel,
    Form,
    FormControl,
    FormGroup,
    Modal
} from 'react-bootstrap'

@observer(['globals', 'invoices'])
export default class CreatePackingSlipModal extends Component {

    constructor(props) {
        super(props)
        
        this.state = {
            serialNumbers: ''
        };
    }

    loadSerialNumbers(props) {
        props.invoices.loadSerialNumbers(props.invoiceId, (serialNumbers) => {
            this.setState({ serialNumbers });
        });
    }

    componentDidMount() {
        if (this.props.invoiceId) {
            this.loadSerialNumbers(this.props);
        }
    }

    closeCreatePackingSlipModal() {        
        if (this.props.onClose) {
            this.props.onClose()            
        }
    }

    serialNumbersChanged(e) {
        this.setState({
            serialNumbers: e.target.value
        })
    }

    savePackingSlip(e) {
        this.props.invoices.saveSerialNumbers(this.props.invoiceId, this.state.serialNumbers, () => {
            browserHistory.push('/packingslip/' + this.props.invoiceId)
        })
    }

    render() {

        return (
            <Modal show={this.props.open} onHide={this.closeCreatePackingSlipModal.bind(this)}>
                <Modal.Header closeButton>
                    <Modal.Title>Enter Device Serial Numbers</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span>Enter each serial on a new line.  DO NOT add commas!</span>
                    <Form horizontal name="serialNumberForm">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <FormGroup>
                                <Col sm={4} componentClass={ ControlLabel } >Serial Numbers:</Col>
                                <Col sm={8}><FormControl componentClass="textarea" rows={6} id="serialNumbers" onChange={ this.serialNumbersChanged.bind(this) } value={ this.state.serialNumbers } /></Col>
                            </FormGroup>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" onClick={ this.savePackingSlip.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Generate Packing Slip</Button>
                    <Button bsStyle="danger" onClick={ this.closeCreatePackingSlipModal.bind(this) }><i className="fa fa-ban" aria-hidden="true"></i> Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/invoices/createpackingslipmodal.js